import type { UtmParams } from "./utm-tracker";

/**
 * Build authorization parameters for Auth0 login
 * Includes UTM parameters and referral code if available
 */
export function buildAuthorizationParams(
	utmParams: UtmParams | null,
	referralCode: string | null = null,
): Record<string, string> {
	const authorizationParams: Record<string, string> = {};

	// Add UTM parameters to authorization params so they're accessible in Auth0 Action
	if (utmParams) {
		if (utmParams["utm-source"])
			authorizationParams.utm_source = utmParams["utm-source"];
		if (utmParams["utm-medium"])
			authorizationParams.utm_medium = utmParams["utm-medium"];
		if (utmParams["utm-campaign"])
			authorizationParams.utm_campaign = utmParams["utm-campaign"];
		if (utmParams["utm-term"])
			authorizationParams.utm_term = utmParams["utm-term"];
		if (utmParams["utm-content"])
			authorizationParams.utm_content = utmParams["utm-content"];
	}

	// Add referral code if available
	if (referralCode) {
		authorizationParams.referral_code = referralCode;
	}

	return authorizationParams;
}
